import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordSetPasswordPath = () => urlHelper(`/forgot-password/set-password`);
